import { render, staticRenderFns } from "./TableProductCheck.vue?vue&type=template&id=59cbc882&scoped=true&"
import script from "./TableProductCheck.vue?vue&type=script&lang=js&"
export * from "./TableProductCheck.vue?vue&type=script&lang=js&"
import style0 from "./TableProductCheck.vue?vue&type=style&index=0&id=59cbc882&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cbc882",
  null
  
)

export default component.exports